import { Separator } from '@talentmesh/ui/components/separator';
import { cn } from '@talentmesh/ui/lib/utils';
import React from 'react';

export function VerticalDivider({ className, ...props }: React.ComponentProps<'div'>) {
    return <Separator orientation="vertical" className={cn('bg-border mx-2 my-0', className)} {...props} />;
}

export function HorizontalDivider({ className, ...props }: React.ComponentProps<'div'>) {
    return <Separator orientation="horizontal" className={cn('bg-border', className)} {...props} />;
}
